export function toJSON() {
  return {
    origin: 11,
    phone_number: null,
    ecsrc: 'native',
    last_updated: null,
    event_type: '',
    cohost_email1: null,
    used_as: null,
    is_host_viewing: true,
    host_ids: [],
    send_on: null,
    user_saved: null,
    event_reminder_0: -172800,
    event_reminder_1: null,
    tracking_data: {
      gallery_category: 'search',
    },
    is_cohost_viewing: false,
    host_id: null,
    message: null,
    rsvp_style: {
      maybe: 'Maybe',
      yes: 'Yes',
      who: "Who's Coming?",
      type: 'default',
      no: 'No',
    },
    sent_on: null,
    city: null,
    location_name: null,
    title: null,
    send_count: null,
    id: null,
    template_type: 'free',
    state: null,
    template_name: 'paintingrainbow_ani',
    widgets: null,
    recurring: null,
    rsvp: null,
    status: 'draft',
    start_datetime: null,
    captcha_verified_on: null,
    legacy_event_tz: null,
    shortlink: null,
    is_invite: true,
    zip_code: null,
    age_of_child: null,
    pledgeling_id: null,
    system_generated: null,
    wishlist: null,
    pledgeling_goal: null,
    is_primary_host_viewing: true,
    is_upcoming: true,
    feed_version: null,
    cohost_name1: null,
    end_datetime: null,
    pending_host_ids: null,
    date_created: null,
    registries: null,
    host_name: null,
    options: {
      inserts: null,
      allow_guests_to_use_polls: null,
      event_option_private_guestlist: false,
      event_option_show_gifting: true,
      cost: null,
      design: null,
      event_option_allow_guest_photo_collect: true,
      event_option_max_guests: null,
      rendered_image_filename: null,
      event_option_allow_invite_more: true,
      event_option_notify_when_guests_rsvp: true,
      write: null,
      offers: null,
      event_option_allow_view_map: true,
      event_option_allow_guest_number: true,
      rendered_image_url: null,
      event_option_disable_feed: false,
      custom_image_region: null,
      event_option_cec_food: null,
      event_option_set_max_guests: false,
      event_option_notify_when_guests_comment: true,
      rendered_image_gs_key: null,
      event_option_max_guest_number: 10,
      event_option_allow_kids: false,
      event_option_enable_sponsored_registry: true,
      gifting_link: null,
    },
    street_address: null,
  };
}

export default {toJSON};
